import AppModal from "@/components/AppModal";
import RpIcon from "@/components/RpIcon";
import { VerifyAction } from "@/constant/VerifyConstant";
import useToggle from "@/hook/useToggle";
import { getTaskId, setTaskRuleParams } from "@/redux/slices/user";
import { Box, Stack, Switch, Typography } from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Security2FA from "./Security2FA";
import RouteConstant from "@/constant/RouteConstant";
import axiosInstance from "@/utils/axios";
import API from "@/constant/API";
import classes from "@/pages/security/css/index.module.less";
import {useTranslation} from "react-i18next";
import {enqueueSnackbar} from "notistack";
import SimpleHeader from "../components/Headers/SimpleHeader";
import {useTheme} from "@mui/material/styles";
import { useConfirm } from "material-ui-confirm";
import { isUserCompleteGuide } from "@/utils/userUtils";
import { StyledSwitch } from "@/styles/CommonStyledComponents";

function SecurityEmail() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user } = useSelector(state => state.user);
  const theme = useTheme();
  const confirm = useConfirm();
  const {
    toggle: show2FA,
    onToggle: onToggleShow2FA,
  } = useToggle(false);
  const [option, setOption] = useState(1); // 1 绑定解绑  2 修改

  const _onChange = () => {
    if (user.emailBindStatus != 1) {
      _doChange();
      return;
    }

    confirm({
      title: t('warning'),
      description: t('security_option_change_alert_prompt'),
      confirmationText: t('confirm'),
      cancellationText: t('cancel'),
    }).then(() => {
      _doChange();
    });
  }

  const _doChange = () => {
    setOption(1);
    setTaskRuleParams({
      action: user.emailBindStatus == 1 ? VerifyAction.CLOSE_EMAIL : VerifyAction.BIND_EMAIL,
    });
    onToggleShow2FA();
  }

  const _bindSwitch = () => {
    return <Stack direction={'row'} alignItems="center" justifyContent="space-between" className={classes["security-switch-module"]}>
      <Stack direction={'column'}>
        <div className={classes['security-type']}>{t('email')}</div>
        <div className={classes['security-account']}>{user.email ?? ''}</div>
      </Stack>
      <StyledSwitch checked={user.emailBindStatus} onClick={_onChange} />
    </Stack>
  }

  const _onChangeEmail = () => {
    if (!isUserCompleteGuide(user)) {
      _doChangeEmail();
      return;
    }

    confirm({
      title: t('warning'),
      description: t('security_option_change_alert_prompt'),
      confirmationText: t('confirm'),
      cancellationText: t('cancel'),
    }).then(() => {
      _doChangeEmail();
    });
  }

  const _doChangeEmail = () => {
    setOption(2);
    setTaskRuleParams({
      action: VerifyAction.UPDATE_EMAIL,
    })
    onToggleShow2FA();
  }

  const _on2FAAllPass = async () => {
    // 绑定或解绑
    if (option == 1) {
      // 解绑
      if (user.emailBindStatus == 1) {
        await axiosInstance.post(API.EMAIL_UNBIND, {
          taskId: getTaskId(),
        });
        // TODO: toast 提示用户解绑成功
        enqueueSnackbar(t('successful'), { variant: 'success' })
        navigate(-1);
        return;
      } 
      // 绑定
      else {
        navigate(RouteConstant.USER_SECURITY_EMAIL_BIND);
      }
    } else {
      navigate(RouteConstant.USER_SECURITY_EMAIL_UPDATE);
    }
  }

  const _changeEmailLink = () => {
    return <Stack
      direction="row"
      alignItems='center'
      justifyContent="space-between"
      onClick={_onChangeEmail}
      className={classes["update-account-wrap"]}
    >
      <Stack
        direction="row"
        alignItems='center'
        gap={1}
      >
        <RpIcon icon="change-x-copy" size={22}/>
        <span>{t('change_email')}</span>
      </Stack>
      <RpIcon icon="arrow-right-simple" size={22}/>
    </Stack>
  }

  if (!user) return null;

  return (<>
    <SimpleHeader />
    <Box className={classes["security-wrap"]}>
      <Box className={classes["security-title-wrap"]}>
        <div className={classes["security-title"]}>{t('email')}</div>
        <div className={classes["security-subtitle"]}>{t('email_subtitle')}</div>
      </Box>

      <Box className={classes["security-img-wrap"]}>
        <img src={theme.palette.mode === 'dark' ? '/images/account/email-dark.svg' : '/images/account/email.svg'} alt=""/>
      </Box>
      <Box>
        {_bindSwitch()}
        {user.emailBindStatus == 1 && _changeEmailLink()}
      </Box>
      <AppModal open={show2FA} onClose={onToggleShow2FA}>
        <Security2FA callback={_on2FAAllPass} onClose={onToggleShow2FA}/>
      </AppModal> 
    </Box>
  </>);
}

export default SecurityEmail;
